import {MenuFormat, PageTitleItem} from "../MenuDocumentModel";
import {ReactElement} from "react";
import {EditorItem} from "../editorUtils";

export interface PageTitlePreviewItemProps {
    format: MenuFormat
    title: EditorItem<PageTitleItem>
}

export function PageTitlePreviewItem(props: PageTitlePreviewItemProps): ReactElement {
    return (
        <h2 className="h-[5.5mm] mb-[5mm] font-barlow font-medium text-[16pt] text-text leading-tight uppercase">
            {props.title.menuItem.title}
        </h2>
    );
}